
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: Storytelling
* Copyright IBM Corp. 2017, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'story': 'История',
	'noDashboardFound': 'Получить историю не удается. Либо она больше не существует, либо у вас недостаточно привилегий для ее просмотра.',
	'noDashboardCapability': 'У вам нет возможности использовать истории.',
	'noDashboardPermision': 'У вас нет необходимых полномочий для просмотра этой истории.',
	'defaultName': 'Новая история',
	'storyProperties': 'Свойства истории',
	'createAvDataStoryLabel': 'История',
	'createAvSlideShowLabel': 'Слайд-шоу',
	'createAvPanAndZoomLabel': 'Путешествие под руководством',
	'dashboard_save_success': 'Ваша история сохранена.',
	'cmEmptySelection': 'История удалена. Попробуйте сохранить ее как новую историю.',
	'createStoryTitle': 'Создать историю',
	'transitionStyleTitle': 'Стиль перехода',
	'createButton': 'Создать',
	'cancelButton': 'Отмена',
	'dashboardResetTitle': 'Сбросить историю',
	'dashboardResetMessage': 'Вы уверены, что хотите произвести сброс всех изменений, примененных к этой истории?',
	'dashboardResetToast': 'Ваша история сброшена.',
	'filter_drag_and_drop_all_tabs': 'Перетащите сюда данные, чтобы применить фильтр ко всем сценам.',
	'filter_drag_and_drop_current_tab': 'Перетащите сюда данные, чтобы применить фильтр к данной сцене.',
	'filterIconLabel_Global': 'Все сцены',
	'filterIconLabel_Tab': 'Данная сцена',
	'filterIconTooltip_Global': 'Все сцены',
	'filterIconTooltip_Tab': 'Данная сцена',
	'filterOverflowMenu_Global': 'Меню переполнения всех сцен',
	'filterOverflowMenu_Tab': 'Меню переполнения данной сцены',
	'renameScene': 'Переименовать сцену',
	'duplicateScene': 'Дублировать сцену',
	'deleteScene': 'Удалить сцену',
	'editTimelineHighlight': 'Изменить выделение',
	'deleteTimelineHighlight': 'Удалить выделение',
	'filter_includesAll': 'Включить все',
	'timeline_highlight_moved_to': 'Выделение временного ряда %{id} перемещено в %{time}',
	'filter_tooltip': '[%{title}] - %{description}',
	'selectLabel': 'Выбрать',
	'newDefaultStoryName': 'История: %{modelName}',
	'exportLabel': 'Сохранить',
	'exportAsLabel': 'Сохранить как:',
	'exportDialogTitle': 'Сохранить как историю',
	'exportDialogFooter': 'Кнопки Сохранить и Отмена',
	'loadAfterExportLabel': 'Открыть историю после сохранения',
	'selectTemplateLabel': 'Выбрать шаблон',
	'outOfBoundsWarningMessage': 'Некоторые виджеты сводной панели находятся вне сетки и, возможно, не будут правильно показаны после экспорта.',
	'emptyExploreCardsWarningMessage': 'Пустые карты были удалены во время сохранения в виде истории',
	'dashboard_export_success': 'Ваша сводная панель успешно сохранена как история.',
	'explore_export_success': 'Исследование успешно сохранено как сюжет.',
	'toastUpgradeDone': 'Ваша сюжет обновлен. Сохраните данные сейчас, чтобы обеспечить оптимальную производительность.',
	'navigationMarker': 'Маркер навигации',
	'navigateMarkers': 'Маркеры навигации',
	'navNextMarker': 'Следующий маркер',
	'navPrevMarker': 'Предыдущий маркер',
	'navPrevMarkerAbbreviated': 'Предыдущий маркер',
	'timelineSettingsButton': 'Опции воспроизведения',
	'autoPlay': 'Воспроизвести все сцены',
	'loop': 'Цикл',
	'refreshData': 'Обновить при запуске',
	'slideshowLabel': 'Слайд-шоу',
	'panAndZoomLabel': 'Путешествие под руководством',
	'slideShowLayoutLabel': 'Схема с показом слайдов',
	'panAndZoomLayoutLabel': 'Схема с путешествием под руководством',
	'panAndZoomLayoutFooter': 'Схема с путешествием под руководством - это собрание сцен на одном холсте. При запуске истории этого типа презентация масштабируется и панорамируется для каждой отдельной сцены в последовательном порядке. Она отличается от схемы с показом слайдов, где каждая сцена представляется на новом холсте. Схема с путешествием под руководством с тремя сценами соединяется линиями, что позволяет создать горизонтальную последовательность сцен. Это удобно для показа временного графика.',
	'PanAndZoomLayout1': '5 сцен, расположенных в прямоугольной форме',
	'PanAndZoomLayout2': '4 сцены, расположенные в виде лестницы, идущей слева направо',
	'PanAndZoomLayout3': '6 сцен, расположенных в прямоугольной форме',
	'PanAndZoomLayout4': '7 сцен, расположенных в прямоугольной форме с 6 меньшими сценами вверху и одной большей сценой внизу',
	'PanAndZoomLayout5': '3 сцены, из которых 2 меньшие сцены расположены вверху, а 1 большая сцена - внизу',
	'PanAndZoomLayout6': 'Последовательность 4 сцен, расположенных по горизонтали',
	'pageSelectWarning': 'Выберите сцену.',
	'noSceneTransitionLabel': 'Нет',
	'sceneTransitionPropertyLabel': 'Переход сцены',
	'animatedPathSceneTransitionLabel': 'Анимированный путь',
	'sweepSceneTransitionLabel': 'Протянуть',
	'storyTypeLabel': 'Тип истории',
	'layoutLabel': 'Схема',
	'tabName_animation': 'Анимация',
	'propAniAnimation': 'Анимация',
	'propAniTypeEntrance': 'Анимация входа',
	'propAniDirectionIn': 'Направление входа',
	'propAniTypeExit': 'Анимация выхода',
	'propAniDirectionOut': 'Направление выхода',
	'propAniDirection': 'Направление',
	'propAniEntrance': 'Вход',
	'propAniTypeEntranceSlideIn': 'Наехать',
	'propAniTypeEntranceFadeIn': 'Постепенное проявление',
	'propAniTypeEntrancePivotIn': 'Прямой поворот',
	'propAniTypeEntranceScaleIn': 'Укрупнить',
	'propAniTypeEntranceShrinkIn': 'Уменьшить',
	'propAniDirectionInLeft': 'Слева',
	'propAniDirectionInRight': 'Справа',
	'propAniDirectionInTop': 'Сверху',
	'propAniDirectionInBottom': 'Снизу',
	'propAniExit': 'Выход',
	'propAniTypeExitSlideIn': 'Отъехать',
	'propAniTypeExitFadeIn': 'Постепенное затухание',
	'propAniTypeExitPivotOut': 'Обратный поворот',
	'propAniTypeExitScaleIn': 'Сделать мельче',
	'propAniTypeExitExpandOut': 'Расширить',
	'propAniDirectionOutLeft': 'Влево',
	'propAniDirectionOutRight': 'Вправо',
	'propAniDirectionOutTop': 'В начало',
	'propAniDirectionOutBottom': 'В конец',
	'propAniEntranceTime': 'Начало (сек):',
	'propAniExitTime': 'Конец (сек):',
	'animationNoEntranceText': 'Входная анимация не произойдет, если виджет будет находиться в начале сцены.',
	'animationNoExitText': 'Выходная анимация не произойдет, если виджет будет находиться в конце сцены.',
	'propAniTypeDataEntrance': 'Ввод данных',
	'propAniRevealDuration': 'Длительность входной анимации',
	'timelineAnimationProperties': 'Открыть свойства анимации',
	'scenesPropertiesSection': 'Сцены',
	'editStoryCoachMarkTitle': 'Изменить историю',
	'editStoryCoachMarkContents': 'Щелкните по значку карандаша, чтобы изменить эту историю.',
	'addDataStoryCoachMarkContents': 'Перетащите данные из панели данных на историю.',
	'expandSceneCoachmarkTitle': 'Открыть временную шкалу',
	'expandSceneCoachmarkContents': 'Анимировать сцену, скорректировав видимость объекта на основе времени и продолжительности.',
	'overviewCoachmarkTitle': 'Обзорные сцены',
	'overviewCoachmarkContents': 'Используйте обзорные сцены в начале и конце истории с целью показать комплексное представление всех сцен. С обзорной сцены щелкните по сцене и перетащите, чтобы поменять её на другую сцену. Обзорные сцены можно показать или скрыть в свойствах истории.',
	'animatedPathCoachmarkTitle': 'Анимированный путь',
	'animatedPathCoachmarkContents': 'Позволяет анимировать объект при переходе от одной сцене к другой, дублировать сцену с объектом. Затем переместите или поверните дублированный объект на новой сцене либо измените его размер.',
	'propShowStoryOverviewFirstSlide': 'Показывать все сцены при запуске',
	'propShowStoryOverviewLastSlide': 'Показывать все сцены при при окончании',
	'storySceneSingleCountLabel': '1 сцена',
	'storySceneCountLabel': '%{count} сцен',
	'storySceneRangeCountLabel': 'Сцена %{index} из %{count}',
	'storySceneExpand': 'Открыть временную шкалу',
	'storySceneActionMenu': 'Меню опция запуска сцен',
	'timelineRightContainerLabel': 'Группа управления кнопками временной шкалы',
	'timelineViewLabel': 'Временная шкала',
	'timelineZoomFit': 'Масштабировать, чтобы уместить',
	'timelineZoomIn': 'Увеличить',
	'timelineZoomOut': 'Уменьшить',
	'timelinePositionIndicator': 'индикатор положения временной шкалы в %{position}',
	'timelinePositionIndicatorMoveLeftTo': 'перемещение индикатора положения временной шкалы влево на %{position}',
	'timelinePositionIndicatorMoveRightTo': 'перемещение индикатора положения временной шкалы вправо на %{position}',
	'sceneStart': 'Перейти к началу сцены в %{position}',
	'sceneEnd': 'Перейти к концу сцены в %{position}',
	'timelineHighlightTitle': 'Выделить',
	'addTimelineHighlight': 'Добавить выделение',
	'addSceneBtnTitle': 'Добавить новую сцену с шаблоном по умолчанию',
	'addSceneChevronBtnTitle': 'Выберите шаблон сцены',
	'timelinePlay': 'Воспроизвести',
	'timelinePause': 'Пауза',
	'sceneNavigation': 'Навигация по сценам',
	'navNextScene': 'Следующая сцена',
	'navPrevScene': 'Предыдущая сцена',
	'navPrevSceneAbbreviated': 'Предыдущая сцена',
	'navExitFullScreen': 'Закрыть полный экран',
	'navToggleOverview': 'Переключить обзор',
	'rowNumber': 'Строка %{number}',
	'overviewBtnLabel': 'Обзор',
	'sceneListStart': 'Начало обзора',
	'sceneListEnd': 'Конец обзора',
	'timelineLeftHandle': 'левый хэндл для %{name}',
	'timelineRightHandle': 'правый хэндл для %{name}',
	'timelineLeftHandleNoTitle': 'левый хэндл',
	'timelineRightHandleNoTitle': 'правый хэндл',
	'timelineMoveLeft': 'Переместить %{object} влево',
	'timelineMoveRight': 'Переместить %{object} вправо',
	'timelineMoveWidget': 'виджет временной шкалы перемещен в %{newStartTime} и %{newEndTime}',
	'timelineMoveWidgetStartTime': 'начальное время виджета временной шкалы изменено на %{newStartTime}',
	'timelineMoveWidgetEndTime': 'конечное время виджета временной шкалы изменено на %{newEndTime}',
	'timelineMoveWidgetDown': 'виджет временной шкалы перемещен вниз',
	'timelineMoveWidgetUp': 'виджет временной шкалы перемещен вверх',
	'addSceneTitle': 'Добавить сцену',
	'blankSceneLayout': 'Пустой',
	'titleSceneLayout': 'Заголовок с подзаголовком',
	'sceneLayout1': 'Заголовок с текстом рядом с одной визуализацией',
	'sceneLayout2': 'Заголовок с одной визуализацией',
	'sceneLayout3': 'Заголовок с двумя визуализациями',
	'sceneLayout4': 'Многоцелевые',
	'sceneLayout5': 'Без заголовка с текстом рядом с одной визуализацией',
	'sceneLayout6': 'Многоцелевые 2 на 2',
	'sceneLayout7': 'Многоцелевые 2 рядом с 1',
	'sceneLayout8': 'Многоцелевые 1 рядом с 2',
	'sceneLayout9': 'Многоцелевые 1 над 2',
	'sceneLayout10': 'Многоцелевые 2 над 1',
	'sceneLayout11': 'Многоцелевые 4 над 1',
	'sceneLayout12': 'Многоцелевые 1 над 1 рядом с 2 на 2 над 1',
	'titleWidgetPlaceholderText': 'Введите заголовок здесь',
	'subtitleWidgetPlaceholderText': 'Введите здесь свой подзаголовок',
	'createStoryViewTitle': 'Создать историю',
	'defaultStoryName': 'Новая история',
	'screenshot_label': 'История %{title}',
	'screenshot_label_scene': 'Сцена %{sceneTitle} из истории %{title}',
	'filmstripHandleOpenLabel': 'Открыть селектор сцен',
	'filmstripHandleCloseLabel': 'Закрыть селектор сцен'
});
